export const darkTheme = {
  bg: "#090917",
  bgLight: "#1C1E27",
  primary: "#E8920C",
  text_primary: "#F5E6CC",
  text_secondary: "#A8845A",
  card: "#171721",
  card_light: "#191924",
  button: "#E8920C",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#f5ece0",
  primary: "#C0501A",
  text_primary: "#1A0E05",
  text_secondary: "#5C3D1E",
  card: "#FFFFFF",
  button: "#C0501A",
};
